import { Navigate, Route, Routes } from 'react-router';
import { Eduplay } from '@/packages/eduplay';
import { Course } from '@/packages/eduplay/pages/course';

export const EduplayRoutes = () => (
  <Routes>
    <Route path={`/curso/:id`} element={<Course />} />
    <Route index element={<Eduplay />} />
    <Route path="*" element={<Navigate to="/meu-aprendizado" replace />} />
  </Routes>
);
